/*
 * Количество из поля: пробелы и неразрывные пробелы разрядов («1 500»),
 * запятая как десятичный знак. null значит не число: по Enter это скан
 * полки, попавший в поле количества (chmk_base, shelf.js).
 */
export function parseQty(raw: string): number | null {
  const s = raw.replace(/[\s\u00a0\u202f]/g, "").replace(",", ".");
  if (!/^-?\d+(\.\d+)?$/.test(s)) return null;
  return Number(s);
}
